import { createApi } from '@reduxjs/toolkit/query/react';

import { AdminAnalytics } from '../endpoints';
import {
  getBaseQuery,
  TransformedErrorResponseWithNotification,
} from '../generic';
import { HTTP_METHOD } from '../constants';
import {
  IUsageEventsQuery,
  IUsageEventsResponse,
} from '../../../types/interfaces/analytics';

function getUsageEventsQueryString(params: IUsageEventsQuery = {}) {
  const query = new URLSearchParams();

  if (params.period) {
    query.set('period', params.period);
  }

  if (typeof params.unique === 'boolean') {
    query.set('unique', String(params.unique));
  }

  if (params.actions?.length) {
    params.actions.forEach((action) => query.append('actions', action));
  }

  return query.toString();
}

export const analyticsAdminApi = createApi({
  reducerPath: 'analyticsAdminApi',
  baseQuery: getBaseQuery(AdminAnalytics.ROOT),
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getUsageEvents: builder.query<IUsageEventsResponse, IUsageEventsQuery>({
      query(params = {}) {
        const queryString = getUsageEventsQueryString(params);
        const url = queryString
          ? `${AdminAnalytics.USAGE_EVENTS}?${queryString}`
          : AdminAnalytics.USAGE_EVENTS;

        return {
          url,
          method: HTTP_METHOD.GET,
        };
      },
      serializeQueryArgs: ({ endpointName, queryArgs }) =>
        `${endpointName}-${JSON.stringify(queryArgs)}`,
      ...TransformedErrorResponseWithNotification(),
    }),
  }),
});

export const { useLazyGetUsageEventsQuery } = analyticsAdminApi;
